<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col :span="24" style="padding-top: 10px;">
          <el-button round @click="createClick">{{generateCustomizeString('add')}}</el-button>
          <el-button round @click="freshClick">{{generateCustomizeString('refresh')}}</el-button>
          <el-dropdown @command="handleCommand" style="margin-left: 20px;">
            <el-button round>
              {{ generateCustomizeString('batchOperation') }}
              <i
                class="el-icon-arrow-down el-icon--right"
              ></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">{{ generateCustomizeString('batchDeleteProducts') }}</el-dropdown-item>
              <el-dropdown-item command="b">{{ generateCustomizeString('batchManageFreeShipping') }}</el-dropdown-item>
              <el-dropdown-item command="c">{{ generateCustomizeString('batchManagePriceBreakDiscount') }}</el-dropdown-item>
              <el-dropdown-item command="d">{{ generateCustomizeString('batchManageFreeGift') }}</el-dropdown-item>
              <el-dropdown-item command="e">{{ generateCustomizeString('batchManageAgentVisibility') }}</el-dropdown-item>
              <el-dropdown-item command="f">{{ generateCustomizeString('batchManageCoupon') }}</el-dropdown-item>
              <el-dropdown-item command="g">{{ generateCustomizeString('batchManageSold') }}</el-dropdown-item>
              <el-dropdown-item command="h">{{ generateCustomizeString('batchManagePromote') }}</el-dropdown-item>
              <el-dropdown-item command="i">{{ generateCustomizeString('batchUpdateBestUseBefore') }}</el-dropdown-item>
              <el-dropdown-item command="j">{{ generateCustomizeString('batchUpdateSpecialPrice') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </el-header>
    <el-header v-if="freeShippingVisible === true" class="operation-panel">
      <el-row>
        <el-button
          @click="updateShippingActivity"
        >{{ generateCustomizeString('updateSelectedGoods') }}</el-button>
        <el-radio-group
          v-model="selectionShippingActivity"
          size="medium"
          @change="isSelectionShippingActivity"
          style="margin-left: 20px;"
        >
          <el-radio :label="false">{{ generateCustomizeString('nonFreeShipping') }}</el-radio>
          <el-radio :label="true">{{ generateCustomizeString('freeShipping') }}</el-radio>
          <el-radio
            :label="this.freeShippingOptions.value"
            v-if="this.freeShippingOptions.label"
          >{{this.freeShippingOptions.label}}</el-radio>
        </el-radio-group>
      </el-row>
    </el-header>
    <el-header v-if="fullReductionVisible === true" class="operation-panel">
      <el-row>
        <el-button @click="updateFullReduction">{{ generateCustomizeString('updateSelectedGoods') }}</el-button>
        <el-select
          v-model="selectionFullReductionOptions"
          :placeholder="generateCustomizeString('fullReductionPromotion')"
          @change="isSelectionFullReductionActivity"
          style="margin-left: 10px;"
        >
          <el-option
            v-for="item in fullReductionOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          @click="updateNoFullReduction"
          style="margin-left: 30px;"
        >{{ generateCustomizeString('updateSelectedGoodsNoPriceBreak') }}</el-button>
      </el-row>
    </el-header>
    <el-header v-if="isGiftVisible === true" class="operation-panel">
      <el-row>
        <el-button @click="updateGift">{{ generateCustomizeString('updateSelectedGoodsFreeGift') }}</el-button>
        <el-button
          @click="updateNoGift"
          style="margin-left: 30px;"
        >{{ generateCustomizeString('updateSelectedGoodsNoFreeGift') }}</el-button>
      </el-row>
    </el-header>
    <el-header v-if="isAgentVisible === true" class="operation-panel">
      <el-row>
        <el-button
          @click="updateAgentVisible"
        >{{ generateCustomizeString('updateSelectedGoodsAgentVisible') }}</el-button>
        <el-button
          @click="updateAgentInvisible"
          style="margin-left: 30px;"
        >{{ generateCustomizeString('updateSelectedGoodsAgentInvisible') }}</el-button>
      </el-row>
    </el-header>
    <el-header v-if="isCouponEnabled === true" class="operation-panel">
      <el-row>
        <el-button
          @click="updateCouponEnabled"
        >{{ generateCustomizeString('updateSelectedGoodsCouponEnabled') }}</el-button>
        <el-button
          @click="updateCouponDisabled"
          style="margin-left: 30px;"
        >{{ generateCustomizeString('updateSelectedGoodsCouponDisabled') }}</el-button>
      </el-row>
    </el-header>
    <el-header v-if="isSoldVisible === true" class="operation-panel">
      <el-row>
        <el-button
          @click="updateSold(true)"
        >{{ generateCustomizeString('updateSelectedGoodsEnableSold') }}</el-button>
        <el-button
          @click="updateSold(false)"
          style="margin-left: 30px;"
        >{{ generateCustomizeString('updateSelectedGoodsDisableSold') }}</el-button>
      </el-row>
    </el-header>
    <el-header v-if="isPromoteVisible === true" class="operation-panel">
      <el-row>
        <el-button
          @click="updatePromote(true)"
        >{{ generateCustomizeString('updateSelectedGoodsEnablePromote') }}</el-button>
        <el-button
          @click="updatePromote(false)"
          style="margin-left: 30px;"
        >{{ generateCustomizeString('updateSelectedGoodsDisablePromote') }}</el-button>
      </el-row>
    </el-header>
    <el-header v-if="isBestUseBeforeAtVisible === true" class="operation-panel">
      <el-row>
        <el-date-picker
          v-model="batchBestUseBeforeAt"
          type="month"
          value-format="yyyy-MM-dd"
          :placeholder="generateCustomizeString('chooseShelfLife')"
          editable
        ></el-date-picker>
        <span style="margin: 0 10px;">{{generateCustomizeString('optionShelifLife')}}</span>
        <el-button @click="updateBestUseBeforeAt(true)">
          {{ generateCustomizeString('updateSelectedGoodsBestUseBeforeAt') }}
        </el-button>
      </el-row>
    </el-header>
    <el-header v-if="isBatchEditSpecialPriceVisible === true" class="operation-panel">
      <el-row>
        <el-input
          :placeholder="generateCustomizeString('batchSpecialPrice')"
          onkeyup="value=value.replace(/[^\d.]/g,'')"
          v-model="batchSpecialPrice"
          style="width: 200px;"
        >
          <template slot="prepend">NZ $</template>
        </el-input>&nbsp;
        <el-date-picker
          v-model="special_price_expired_at"
          type="datetime"
          :placeholder="generateCustomizeString('chooseDate')"
          style="width: 300px;"
        ></el-date-picker>&nbsp;
        <el-button @click="batchUpdateSpecialPrice" type="primary">{{ generateCustomizeString('update') }}</el-button>
      </el-row>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-form ref="searchForm" :inline="true" :model="searchForm" class="search-form-inline">
            <el-col :span="24">
              <el-form-item :label="generateCustomizeString('searchInfo')">
                <el-input
                  v-model="searchForm.key"
                  :placeholder="generateCustomizeString('searchInfo')"
                  @keyup.enter.native="onSubmit"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="generateCustomizeString('merchandiseCategories')"
                style="margin-left: 20px;"
              >
                <el-cascader
                  expand-trigger="hover"
                  :options="categoriesOptions"
                  v-model="searchForm.selectedOptions"
                  @change="handleChange"
                  change-on-select
                ></el-cascader>
              </el-form-item>
              <el-form-item :label="generateCustomizeString('merchandiseBrand')">
                <el-select
                  v-model="searchForm.brand_id"
                  :placeholder="generateCustomizeString('selectBrand')"
                  filterable
                >
                  <el-option
                    v-for="item in brandOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="generateCustomizeString('barcode')">
                <el-input
                  v-model="searchForm.bar_code"
                  :placeholder="generateCustomizeString('barcode')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="generateCustomizeString('PriceBreakPromotion')">
                <el-select
                  v-model="searchForm.full_reduction_activity_id"
                  :placeholder="generateCustomizeString('PriceBreakPromotion')"
                  style="width: 180px;"
                >
                  <el-option
                    v-for="item in fullReductionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="generateCustomizeString('basePrice')"
                style="margin-left: 20px;"
              >
                <el-input
                  v-model="searchForm.min_price_min"
                  placeholder="0"
                  style="width: 100px;"
                  onkeyup="value=value.replace(/[^\d.]/g,'')"
                  @change="setTwoNumberDecimal()"
                ></el-input>
              </el-form-item>
              <el-form-item label="—">
                <el-input
                  v-model="searchForm.min_price_max"
                  placeholder="9999"
                  style="width: 100px;"
                  onkeyup="value=value.replace(/[^\d.]/g,'')"
                  @change="setTwoNumberDecimal()"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="generateCustomizeString('freeShippingPromotion')"
                style="margin-left: 30px;"
              >
                <el-radio-group
                  v-model="shippingActivity"
                  size="medium"
                  @change="isShippingActivity"
                >
                  <el-radio :label="false">{{ generateCustomizeString('nonFreeShipping') }}</el-radio>
                  <el-radio :label="true">{{ generateCustomizeString('freeShipping') }}</el-radio>
                  <el-radio
                    :label="this.freeShippingOptions.value"
                    v-if="this.freeShippingOptions.label"
                  >{{this.freeShippingOptions.label}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="generateCustomizeString('onOff')" style="margin-left: 14px;">
                <!-- <el-checkbox v-model="is_sold" @change="isSold">未上架</el-checkbox> -->
                <el-select
                  v-model="is_sold"
                  :placeholder="generateCustomizeString('onOff')"
                  @change="isSold"
                  style="width: 180px;"
                >
                  <el-option key="all" :label="generateCustomizeString('all')" value="all"></el-option>
                  <el-option key="on" :label="generateCustomizeString('on')" value="on"></el-option>
                  <el-option key="off" :label="generateCustomizeString('off')" value="off"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-left: 20px;">
                <el-checkbox
                  v-model="searchForm.is_alarm"
                >{{generateCustomizeString('isStockAlarm')}}</el-checkbox>
              </el-form-item>
              <el-form-item style="margin-left: 15px;">
                <el-checkbox
                  v-model="is_sold_out"
                  @change="isSoldOut"
                >{{ generateCustomizeString('soldOut') }}</el-checkbox>
              </el-form-item>
              <el-form-item style="margin-left: 15px;">
                <el-checkbox
                  v-model="is_gift"
                  @change="isGift"
                >{{ generateCustomizeString('freeGift') }}</el-checkbox>
              </el-form-item>
              <el-form-item style="margin-left: 15px;">
                <el-checkbox
                  v-model="is_timed_special_price"
                  @change="isSpecialPrice"
                >{{ generateCustomizeString('limitedTimeDiscount') }}</el-checkbox>
              </el-form-item>
              <el-form-item
                style="margin-left: 15px;"
                :label="generateCustomizeString('goodsSort')"
              >
                <el-select
                  v-model="order_by"
                  :placeholder="generateCustomizeString('pleaseChoose')"
                  @change="orderSortClick"
                  style="width: 160px;"
                >
                  <el-option
                    v-for="item in orderByOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="generateCustomizeString('bestUseAt')"
                style="margin-left: 14px;"
              >
                <el-date-picker
                  v-model="bestDateArray"
                  type="monthrange"
                  :range-separator="generateCustomizeString('to')"
                  :start-placeholder="generateCustomizeString('startDate')"
                  :end-placeholder="generateCustomizeString('endDate')"
                  style="width: 380px;"
                ></el-date-picker>
              </el-form-item>
              <el-form-item style="margin-left: 30px;">
                <el-button
                  type="primary"
                  @click="onSubmit"
                >{{generateCustomizeString('searchSubmit')}}</el-button>
                <el-button @click="onReset">{{generateCustomizeString('reset')}}</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="merchandiseData"
        tooltip-effect="dark"
        style="width: 100%; margin-bottom:60px;"
        v-loading.body="merchandiseListLoading"
        @selection-change="handleSelectionChange"
        border
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- <el-table-column prop="product_spu_unique" :label="generateCustomizeString('merchandiseId')" width="160">
        </el-table-column>-->
        <el-table-column :label="generateCustomizeString('merchandiseThumbnail')" width="120">
          <template slot-scope="scope">
            <el-popover placement="top-start" width="230" trigger="hover">
              <div>
                <div :id="'image'+scope.row.id">
                  <div>
                    <qrcode :value="createQRCodeURL(scope.row.id)" :options="{ width: 200 }"></qrcode>
                  </div>
                </div>

                <div>
                  <el-button @click="createQrcode(scope.row)">Download</el-button>
                </div>
              </div>
              <div></div>

              <img
                v-if="scope.row.images.length"
                :src="scope.row.images[0].image_url + '?imageView2/1/w/200/h/200/q/75|imageslim'"
                slot="reference"
                style="width:auto;height:100px;"
              />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('merchandiseName')" width="300">
          <template slot-scope="scope">
            <span>{{scope.row.product_name}}</span>
            <br />
            <span>{{ generateCustomizeString('merchandiseBrand') }}: {{scope.row.brand.brand_name}}</span>
            <br />
            <span>{{ generateCustomizeString('categories') }}: {{scope.row.category.name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          :label="generateCustomizeString('merchandisePrice')"
          width="120"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.special_price_expired_at && !isPromotionExpired(scope.row.special_price_expired_at)">
              <div>
                <span
                  class="origin-price"
                  v-if="scope.row.min_price == scope.row.max_price"
                >{{scope.row.min_price | formatPrice}}</span>
                <span
                  class="origin-price"
                  v-else
                >{{scope.row.min_price | formatPrice}} — {{scope.row.max_price | formatPrice}}</span>
              </div>
              <div>
                <span
                  class="special-price"
                  v-if="scope.row.minSpecialPrice == scope.row.maxSpecialPrice"
                >{{scope.row.minSpecialPrice | formatPrice}}</span>
                <span
                  class="special-price"
                  v-else
                >{{scope.row.minSpecialPrice | formatPrice}} — {{scope.row.maxSpecialPrice | formatPrice}}</span>
              </div>
            </div>
            <div v-else>
              <span
                class="price-font"
                v-if="scope.row.min_price == scope.row.max_price"
              >{{scope.row.min_price | formatPrice}}</span>
              <span
                class="price-font"
                v-else
              >{{scope.row.min_price | formatPrice}} — {{scope.row.max_price | formatPrice}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="best_use_before_at"
          :label="generateCustomizeString('bestUseBefore')"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.best_use_before_at == null"
            >{{ generateCustomizeString('Latest') }}</span>
            <span
              :class="{ active: Date.parse(new Date(scope.row.best_use_before_at)) - (1000 * 60 * 60 * 24 * 180) < new Date().getTime() }"
              v-else
            >{{scope.row.best_use_before_at}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="sort_by"
          :label="generateCustomizeString('merchandiseSortWeight')"
        ></el-table-column>
        <el-table-column
          prop="activity"
          :label="generateCustomizeString('merchandiseActivity')"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_sold"
              :active-value="1"
              :inactive-value="0"
              @change="editGoodsStatus(scope)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="recommend"
          :label="generateCustomizeString('merchandiseRecommend')"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_promote"
              :active-value="1"
              :inactive-value="0"
              @change="editGoodsRecommend(scope)"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column :label="generateCustomizeString('promotion')" width="170">
          <template slot-scope="scope">
            <p>
              <el-tag v-if="scope.row.is_free_shipping === 1">
                {{ generateCustomizeString('freeShipping') }}
              </el-tag>
            </p>
            <p>
              <el-tag v-if="scope.row.free_shipping_activity">
                {{ scope.row.free_shipping_activity.title }}
              </el-tag>
            </p>
            <p>
              <el-tag
                v-if="scope.row.full_reduction_activity && !isPromotionExpired(scope.row.full_reduction_activity.expired_at)"
              >
                {{scope.row.full_reduction_activity.title}}
              </el-tag>
            </p>
            <p>
              <el-tag v-if="scope.row.is_gift === 1">
                {{ generateCustomizeString('freeGift') }}
              </el-tag>
            </p>
            <p>
              <el-tag v-if="scope.row.special_price_expired_at">
                <span v-if="scope.row.special_price_expired_at">
                  {{ generateCustomizeString('limitedTimeDiscount') }}
                </span>
                <span v-if="scope.row.special_price_expired_at && isPromotionExpired(scope.row.special_price_expired_at)" class="expired">
                  ({{ generateCustomizeString('expired') }})
                </span>
                <div
                  v-else-if="scope.row.special_price_expired_at && !isPromotionExpired(scope.row.special_price_expired_at)"
                  style="color: green;"
                >
                  ( {{scope.row.special_price_expired_at}} )
                </div>
              </el-tag>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          :label="generateCustomizeString('StockOperation')"
          width="120"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              @click="viewStockDetails(scope.row)"
              size="small"
              type="text"
            >{{ generateCustomizeString('stockDetail') }}</el-button>
          </template>
        </el-table-column>
        <el-table-column width="80" fixed="right" :label="generateCustomizeString('operate')">
          <template slot-scope="scope">
            <el-button
              @click="editClick(scope.row)"
              type="text"
              size="small"
            >{{generateCustomizeString('edit')}}</el-button>
            <br />
            <el-button
              type="text"
              size="small"
              @click="deleteClick(scope.row)"
            >{{generateCustomizeString('delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:10px;">
      <el-row type="flex">
        <el-col style="padding-top: 5px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfGoods"
            layout="total, prev, pager, next"
            :total="currentTotal"
          ></el-pagination>
        </el-col>
        <el-col>
          <div style="position: fixed; right: 30px;">
            <span style="font-size: 14px; color: #606266;">{{ generateCustomizeString('perPage') }}</span>
            <el-select v-model="numOfGoods" style="width: 100px;" @change="selectNumOfGodds()">
              <el-option
                v-for="item in numOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
    </el-footer>

    <el-dialog
      :title="generateCustomizeString('noticeConfirm')"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <span>{{generateCustomizeString('deleteProduct')}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{generateCustomizeString('deleteCancel')}}</el-button>
        <el-button
          type="primary"
          @click="deleteMerchandise()"
        >{{generateCustomizeString('deleteConfirm')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('stockDetail')"
      :visible.sync="dialogStockDetailsVisible"
      width="60%"
      :append-to-body="true"
    >
      <el-input
        v-model="this.goodsName"
        :disabled="true"
        style="width: 96%; margin: 0 10px 10px 10px;"
      ></el-input>
      <el-table :data="skuTableData" border style="width: 96%; margin: 10px;">
        <el-table-column
          prop="name"
          label="SKU"
          align="center"
          v-if="this.keys[0] !== 'property_default'"
        ></el-table-column>
        <el-table-column
          :label="generateCustomizeString('priceSoldNz')"
          prop="skuPrice"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              v-model="skuTableData[scope.$index].price"
              type="number"
              min="0"
              @change="setTwoNumberDecimal()"
            >
              <template slot="prepend">NZD $</template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          :label="generateCustomizeString('productStock')"
          prop="skuStock"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              v-model="skuTableData[scope.$index].stock"
              type="number"
              min="0"
              @change="setInt()"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          :label="generateCustomizeString('stockAlarm')"
          prop="skuStockAlarm"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              v-model="skuTableData[scope.$index].stock_alarm"
              type="number"
              min="0"
              @change="setInt()"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-button
        size="small"
        v-if="this.keys[0] !== 'property_default'"
        style="margin: 5px 0 0 10px;"
        @click="editAllPriceDialog = true"
      >{{ generateCustomizeString('batchEditPrice') }}</el-button>
      <el-button
        size="small"
        v-if="this.keys[0] !== 'property_default'"
        style="margin: 5px 0 0 10px;"
        @click="editAllStockDialog = true"
      >{{ generateCustomizeString('batchEditStock') }}</el-button>
      <el-button
        size="small"
        v-if="this.keys[0] !== 'property_default'"
        style="margin: 5px 0 0 10px;"
        @click="editAllStockAlarmDialog = true"
      >{{ generateCustomizeString('batchSetStockAlert') }}</el-button>
      <div style="text-align: center; padding: 20px 0 10px 0;">
        <el-button
          @click="dialogStockDetailsVisible = false"
          style="width: 100px; margin-right: 30px;"
        >{{generateCustomizeString('cancel')}}</el-button>
        <el-button
          type="primary"
          @click="updateStockClick"
          style="width: 100px;"
        >{{ generateCustomizeString('update') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('batchEditPrice')"
      :visible.sync="editAllPriceDialog"
      width="30%"
    >
      <el-input
        v-model="editAllPrice"
        :placeholder="generateCustomizeString('batchEditPrice')"
        @keyup.enter.native="editAllSkuPrice"
      >
        <template slot="prepend">NZD $</template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editAllPriceDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button type="primary" @click="editAllSkuPrice">{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('batchEditStock')"
      :visible.sync="editAllStockDialog"
      width="30%"
    >
      <el-input
        v-model="editAllStock"
        :placeholder="generateCustomizeString('batchEditStock')"
        @keyup.enter.native="editAllSkuStock"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editAllStockDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button type="primary" @click="editAllSkuStock">{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('batchSetStockAlert')"
      :visible.sync="editAllStockAlarmDialog"
      width="30%"
    >
      <el-input
        v-model="editAllStockAlarm"
        :placeholder="generateCustomizeString('batchSetStockAlert')"
        @keyup.enter.native="editAllSkuStockAlarm"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editAllStockAlarmDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="editAllSkuStockAlarm"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirm')"
      :visible.sync="deleteSelectionGoodsDialog"
      width="60%"
      style="margin-bottom: 70px;"
    >
      <el-table :data="selections" border style="width: 95%; margin: 0px auto;">
        <el-table-column
          prop="product_spu_unique"
          :label="generateCustomizeString('merchandiseId')"
          width="200"
        ></el-table-column>
        <el-table-column prop="product_name" :label="generateCustomizeString('searchInfo')"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="deleteSelectionGoodsDialog = false"
        >{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="selectionDeleteConfirm"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoods') + ' ' +this.selectionShippingActivityName"
      :visible.sync="shippingActivityDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="shippingActivityDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateShippingActivityConfirm"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoods') + ' ' + this.selectionFullReductionActivityName"
      :visible.sync="fullReductionActivityDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="fullReductionActivityDialog = false"
        >{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateFullReductionActivityConfirm(true)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsNoPriceBreak')"
      :visible.sync="noFullReductionActivityDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="noFullReductionActivityDialog = false"
        >{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateFullReductionActivityConfirm(false)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 买赠 -->
    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsPriceBreak')"
      :visible.sync="giftActivityDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="giftActivityDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateGiftActivityConfirm(true)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsNoFreeGift')"
      :visible.sync="noGiftActivityDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="noGiftActivityDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateGiftActivityConfirm(false)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 代理商可见 -->
    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsAgentVisible')"
      :visible.sync="agentVisibleDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="agentVisibleDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateAgentVisibility(true)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsAgentInvisible')"
      :visible.sync="agentInvisibleDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="agentInvisibleDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateAgentVisibility(false)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 优惠券可用 -->
    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsCouponEnabled')"
      :visible.sync="couponEnabledDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="couponEnabledDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateCouponConfirm(true)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsCouponDisabled')"
      :visible.sync="couponDisabledDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="couponDisabledDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateCouponConfirm(false)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 上下架 -->
    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsSoldEnable')"
      :visible.sync="enableSoldActivityDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="enableSoldActivityDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateSoldActivityConfirm(true)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsSoldDisable')"
      :visible.sync="disableSoldActivityDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="disableSoldActivityDialog = false"
        >{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateSoldActivityConfirm(false)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 推荐 -->
    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsPromoteEnable')"
      :visible.sync="enablePromoteActivityDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="enablePromoteActivityDialog = false"
        >{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updatePromoteActivityConfirm(true)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsPromoteDisable')"
      :visible.sync="disablePromoteActivityDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="disablePromoteActivityDialog = false"
        >{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updatePromoteActivityConfirm(false)"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>
    <!-- 保质期 -->
    <el-dialog
      :title="generateCustomizeString('confirmUpdateSelectedGoodsBestUseBeforeAt')"
      :visible.sync="bestUseBeforeAtActivityDialog"
      width="30%"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="bestUseBeforeAtActivityDialog = false">{{ generateCustomizeString('cancel') }}</el-button>
        <el-button
          type="primary"
          @click="updateBestUseBeforeAtActivityConfirm()"
        >{{ generateCustomizeString('confirm') }}</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import { floatPriceCovertToIntPrice } from '@/utils/helper'
import QRCode from 'qrcode'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import dayjs from 'dayjs'

const originSearchFrom = {
  key: '',
  bar_code: '',
  brand_id: '',
  selectedOptions: [],
  is_alarm: null,
  is_sold: null,
  is_sold_out: null,
  is_gift: null,
  is_free_shipping: null,
  is_timed_special_price: null,
  full_reduction_activity_id: null,
  free_shipping_activity_id: null,
  min_price_min: null,
  min_price_max: null,
  start_best_use_before_at: null,
  end_best_use_before_at: null
}
export default {
  name: 'Management',
  components: {
    [VueQrcode.name]: VueQrcode
  },
  data() {
    return {
      batchBestUseBeforeAt: null,
      bestDateArray: [],
      multipleSelection: [],
      merchandiseData: [],
      merchandiseDataSku: [],
      merchandiseListLoading: false,
      selectGoodsId: 0,
      currentPage: 1,
      currentTotal: 0,
      dialogVisible: false,
      dialogStockFormVisible: false,
      dialogStockDetailsVisible: false,
      deleteSelectionGoodsDialog: false,
      shippingActivityDialog: false,
      fullReductionActivityDialog: false,
      noFullReductionActivityDialog: false,
      giftActivityDialog: false,
      bestUseBeforeAtActivityDialog: false,
      noGiftActivityDialog: false,
      agentVisibleDialog: false,
      agentInvisibleDialog: false,
      couponEnabledDialog: false,
      couponDisabledDialog: false,
      enableSoldActivityDialog: false,
      disableSoldActivityDialog: false,
      enablePromoteActivityDialog: false,
      disablePromoteActivityDialog: false,
      freeShippingVisible: false,
      fullReductionVisible: false,
      isGiftVisible: false,
      isAgentVisible: false,
      isCouponEnabled: false,
      isSoldVisible: false,
      isPromoteVisible: false,
      isBestUseBeforeAtVisible: false,
      searchForm: Object.assign({}, originSearchFrom),
      filters: {},
      stockForm: {
        // product_name: '',
        // price_market_nz: 0,
        // price_market: 0,
        // price_sold_nz: 0,
        // price_sold: 0,
        // stock: 0,
        // stock_alarm: 0
      },
      categoriesOptions: [],
      brandOptions: [],
      fullReductionOptions: [],
      getdate: '',
      dynamicProperty: [],
      keys: [],
      values: [],
      values2: [],
      skuImgKey: [],
      skuTableData: [],
      propertyName: [],
      goodsName: '',
      goodsStockId: '',
      editAllPriceDialog: false,
      editAllStockDialog: false,
      editAllStockAlarmDialog: false,
      editGoodsReadyDialog: false,
      editAllPrice: '',
      editAllStock: '',
      editAllStockAlarm: '',
      selections: [],
      numOfGoods: 15,
      numOptions: [
        {
          value: 15,
          label: '15'
        },
        {
          value: 50,
          label: '50'
        },
        {
          value: 100,
          label: '100'
        },
        {
          value: 500,
          label: '500'
        },
        {
          value: 1000,
          label: '1000'
        }
      ],
      is_sold: null,
      is_alarm: false,
      is_sold_out: false,
      is_gift: false,
      is_timed_special_price: false,
      shippingActivity: '',
      freeShippingOptions: {},
      selectionShippingActivity: '',
      selectionShippingActivityName: '',
      selectionFullReductionActivityName: '',
      selectionFullReductionOptions: '',
      order_by: '',
      order_turn: '',
      orderByOptions: [
        {
          value: 'min_price',
          label: this.generateCustomizeString('priceAsc')
        },
        {
          value: 'max_price',
          label: this.generateCustomizeString('priceDesc')
        },
        {
          value: 'special_price_expired_at',
          label: this.generateCustomizeString('specialPriceExpiredAsc')
        }
      ],

      rules: {
        price_sold_nz: [
          {
            required: true,
            // type: 'number',
            // pattern: '^[0-9]+(.[0-9]{1,2})?$',
            message: this.generateCustomizeString('pleaseInputNZDSalePrice'),
            trigger: 'blur'
          }
        ],
        price_sold: [
          {
            required: true,
            // type: 'number',
            // pattern: '^[0-9]+(.[0-9]{1,2})?$',
            message: this.generateCustomizeString('pleaseInputCNYSalePrice'),
            trigger: 'blur'
          }
        ],
        price_market_nz: [
          {
            // required: true,
            type: 'number',
            // pattern: '^[0-9]+(.[0-9]{1,2})?$',
            message: this.generateCustomizeString('pleaseInputNZDMarketPrice'),
            trigger: 'blur'
          }
        ],
        price_market: [
          {
            // required: true,
            type: 'number',
            // pattern: '^[0-9]+(.[0-9]{1,2})?$',
            message: this.generateCustomizeString('pleaseInputCNYMarketPrice'),
            trigger: 'blur'
          }
        ],
        stock: [
          {
            required: true,
            type: 'number',
            // pattern: '^([1-9][0-9]*)$',
            message: this.generateCustomizeString('pleaseInputCorrectStock'),
            trigger: 'blur'
          }
        ],
        stock_alarm: [
          {
            // required: true,
            type: 'number',
            // pattern: '^([1-9][0-9]*)$',
            message: this.generateCustomizeString(
              'pleaseInputCorrectStockAlert'
            ),
            trigger: 'blur'
          }
        ]
      },
      batchSpecialPrice: '',
      isBatchEditSpecialPriceVisible: false,
      special_price_expired_at: ''
    }
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    },
    isPromotionExpired() {
      return function(date) {
        if (new Date().getTime() < new Date(date).getTime()) {
          return false
        } else {
          return true
        }
      }
    }
  },
  methods: {
    generateCustomizeString,
    handleCommand(command) {
      console.log(command)
      this.freeShippingVisible = false
      this.fullReductionVisible = false
      this.isGiftVisible = false
      this.isAgentVisible = false
      this.isCouponEnabled = false
      this.isSoldVisible = false
      this.isPromoteVisible = false
      this.isBestUseBeforeAtVisible = false
      this.isBatchEditSpecialPriceVisible = false
      switch (command) {
        case 'a':
          this.selectionDelete()
          break
        case 'b':
          this.freeShippingVisible = !this.freeShippingVisible
          break
        case 'c':
          this.fullReductionVisible = !this.fullReductionVisible
          break
        case 'd':
          this.isGiftVisible = !this.isGiftVisible
          break
        case 'e':
          this.isAgentVisible = !this.isAgentVisible
          break
        case 'f':
          this.isCouponEnabled = !this.isCouponEnabled
          break
        case 'g':
          this.isSoldVisible = !this.isSoldVisible
          break
        case 'h':
          this.isPromoteVisible = !this.isPromoteVisible
          break
        case 'i':
          this.isBestUseBeforeAtVisible = !this.isBestUseBeforeAtVisible
          break
        case 'j':
          this.isBatchEditSpecialPriceVisible = !this.isBatchEditSpecialPriceVisible
          break
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    isAlarm() {
      if (this.is_alarm === true) {
        this.searchForm.is_alarm = 1
      } else {
        this.searchForm.is_alarm = 0
      }
    },
    isSold() {
      if (this.is_sold === 'all') {
        this.searchForm.is_sold = null
      } else if (this.is_sold === 'on') {
        this.searchForm.is_sold = 1
      } else {
        this.searchForm.is_sold = 0
      }
    },
    isSoldOut() {
      if (this.is_sold_out === true) {
        this.searchForm.is_sold_out = 1
      } else {
        this.searchForm.is_sold_out = 0
      }
    },
    isGift() {
      if (this.is_gift === true) {
        this.searchForm.is_gift = 1
      } else {
        this.searchForm.is_gift = 0
      }
    },
    isSpecialPrice() {
      if (this.is_timed_special_price === true) {
        this.searchForm.is_timed_special_price = 1
        this.order_by = 'special_price_expired_at'
        this.order_turn = 'desc'
      } else {
        this.searchForm.is_timed_special_price = 0
        this.order_by = ''
        this.order_turn = ''
      }
    },
    isShippingActivity() {
      if (this.shippingActivity === false) {
        this.searchForm.is_free_shipping = 0
      } else if (this.shippingActivity === true) {
        this.searchForm.is_free_shipping = 1
      } else {
        this.searchForm.free_shipping_activity_id = this.shippingActivity
      }
    },
    isSelectionShippingActivity() {
      if (this.selectionShippingActivity === false) {
        this.selectionShippingActivityName = this.generateCustomizeString(
          'nonFreeShipping'
        )
      } else if (this.selectionShippingActivity === true) {
        this.selectionShippingActivityName = this.generateCustomizeString(
          'freeShipping'
        )
      } else {
        this.selectionShippingActivityName = this.freeShippingOptions.label
      }
    },
    isSelectionFullReductionActivity() {
      for (var i = 0; i < this.fullReductionOptions.length; i++) {
        if (
          this.selectionFullReductionOptions ===
          this.fullReductionOptions[i].value
        ) {
          this.selectionFullReductionActivityName = this.fullReductionOptions[
            i
          ].label
        }
      }
    },
    orderSortClick() {
      if (this.order_by === 'min_price') {
        this.order_turn = 'asc'
        this.filters.is_timed_special_price = 0
        this.is_timed_special_price = false
      } else if (this.order_by === 'max_price') {
        this.order_turn = 'desc'
        this.filters.is_timed_special_price = 0
        this.is_timed_special_price = false
      } else if (this.order_by === 'special_price_expired_at') {
        this.order_turn = 'desc'
        this.is_timed_special_price = true
        this.filters.is_timed_special_price = 1
        // this.onSubmit()
        // return
      }
      this.fetchData(this.currentPage)
    },
    selectionDelete() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }
      console.log(this.selections)
      this.deleteSelectionGoodsDialog = true
    },
    selectionDeleteConfirm() {
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }
      console.log(selectIds)
      request({
        url: 'goods/batch',
        method: 'delete',
        data: {
          ids: selectIds
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successDeleted'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('deleteFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.deleteSelectionGoodsDialog = false
          this.fetchData(this.currentPage)
        })
    },
    updateShippingActivity() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }
      if (this.selectionShippingActivity === '') {
        this.$message.info(
          this.generateCustomizeString('pleaseChooseFreeShippingPromotion')
        )
        return
      }
      this.shippingActivityDialog = true
    },
    updateShippingActivityConfirm() {
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }
      console.log(selectIds)
      var data = {}
      if (
        this.selectionShippingActivity === true ||
        this.selectionShippingActivity === false
      ) {
        data = {
          is_free_shipping: this.selectionShippingActivity,
          free_shipping_activity_id: ''
        }
      } else {
        data = {
          is_free_shipping: false,
          free_shipping_activity_id: this.selectionShippingActivity
        }
      }
      request({
        url: 'goods/batch/update',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successUpdated'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.shippingActivityDialog = false
          this.fetchData(this.currentPage)
        })
    },
    updateFullReduction() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }
      if (this.selectionFullReductionOptions === '') {
        this.$message.info(
          this.generateCustomizeString('pleaseChoosePriceBreakPromotion')
        )
        return
      }
      this.fullReductionActivityDialog = true
    },
    updateNoFullReduction() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }
      this.noFullReductionActivityDialog = true
    },
    updateFullReductionActivityConfirm(activity) {
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }
      console.log(selectIds)
      var data = {}
      if (activity === true) {
        data = {
          full_reduction_activity_id: this.selectionFullReductionOptions
        }
      } else {
        data = {
          full_reduction_activity_id: ''
        }
      }
      request({
        url: 'goods/batch/update',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successUpdated'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.fullReductionActivityDialog = false
          this.noFullReductionActivityDialog = false
          this.fetchData(this.currentPage)
        })
    },
    batchUpdateSpecialPrice() {
      if (this.batchSpecialPrice === '') {
        this.$message({
          message: this.generateCustomizeString('pleaseSpecifyBatchSpecialPrice'),
          type: 'warning'
        })
        return
      }
      if ((this.batchSpecialPrice !== '' && this.special_price_expired_at === '') ||
      (this.batchSpecialPrice !== '' && this.special_price_expired_at === null)) {
        this.$message({
          message: this.generateCustomizeString('pleaseChooseEndDate'),
          type: 'warning'
        })
        return
      }
      this.selections = this.$refs.multipleTable.selection
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }
      const data = {
        timed_special_price: this.batchSpecialPrice * 1000000 / 10000,
        special_price_expired_at: dayjs(this.special_price_expired_at).utc().format('YYYY-MM-DD HH:mm:ss')
      }
      request({
        url: 'goods/batch/update',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then((res) => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successUpdated'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.isBatchEditSpecialPriceVisible = false
          this.fetchData(this.currentPage)
          // 清空一下数据
          this.batchSpecialPrice = ''
          this.special_price_expired_at = ''
        })
    },
    updateGift() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }
      this.giftActivityDialog = true
    },
    updateNoGift() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }
      this.noGiftActivityDialog = true
    },

    updateSold(flag) {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }

      if (flag) {
        this.enableSoldActivityDialog = true
      } else {
        this.disableSoldActivityDialog = true
      }
    },
    updatePromote(flag) {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }

      if (flag) {
        this.enablePromoteActivityDialog = true
      } else {
        this.disablePromoteActivityDialog = true
      }
    },
    updateAgentVisible() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }
      this.agentVisibleDialog = true
    },
    updateAgentInvisible() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }
      this.agentInvisibleDialog = true
    },
    updateCouponEnabled() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }
      this.couponEnabledDialog = true
    },
    updateCouponDisabled() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }
      this.couponDisabledDialog = true
    },
    updateBestUseBeforeAt() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseProducts'))
        return
      }

      this.bestUseBeforeAtActivityDialog = true
    },
    updateGiftActivityConfirm(activity) {
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }
      console.log(selectIds)
      var data = {}
      if (activity === true) {
        data = {
          is_gift: true
        }
      } else {
        data = {
          is_gift: false
        }
      }
      request({
        url: 'goods/batch/update',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successUpdated'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.giftActivityDialog = false
          this.noGiftActivityDialog = false
          this.fetchData(this.currentPage)
        })
    },
    updateSoldActivityConfirm(activity) {
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }
      console.log(selectIds)
      var data = {}
      if (activity === true) {
        data = {
          is_sold: true
        }
      } else {
        data = {
          is_sold: false
        }
      }
      request({
        url: 'goods/batch/update',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successUpdated'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.enableSoldActivityDialog = false
          this.disableSoldActivityDialog = false
          this.fetchData(this.currentPage)
        })
    },
    updatePromoteActivityConfirm(activity) {
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }

      const data = { is_promote: activity }

      request({
        url: 'goods/batch/update',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successUpdated'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.enablePromoteActivityDialog = false
          this.disablePromoteActivityDialog = false
          this.fetchData(this.currentPage)
        })
    },
    updateAgentVisibility(type) {
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }
      var data = {
        is_agent_visible: type
      }
      request({
        url: 'goods/batch/update',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successUpdated'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.agentVisibleDialog = false
          this.agentInvisibleDialog = false
          this.fetchData(this.currentPage)
        })
    },
    updateCouponConfirm(type) {
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }
      var data = {
        coupon_enabled: type
      }
      request({
        url: 'goods/batch/update',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successUpdated'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.couponEnabledDialog = false
          this.couponDisabledDialog = false
          this.fetchData(this.currentPage)
        })
    },
    updateBestUseBeforeAtActivityConfirm() {
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }

      let best_use_before_at = null
      if (this.batchBestUseBeforeAt) {
        best_use_before_at = dayjs(
          this.batchBestUseBeforeAt,
          'YYYY-MM-DD'
        )
          .endOf('month')
          .utc()
          .format('YYYY-MM-DD')
      }
      const data = { best_use_before_at: best_use_before_at }
      request({
        url: 'goods/batch/update',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successUpdated'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.bestUseBeforeAtActivityDialog = false
          this.fetchData(this.currentPage)
        })
    },
    selectNumOfGodds() {
      this.fetchData(1)
    },
    setTwoNumberDecimal(event) {
      for (var i = 0; i < this.skuTableData.length; i++) {
        const item = this.skuTableData[i]
        item.price = parseFloat(item.price).toFixed(2)
      }
      if (this.searchForm.min_price_min) {
        this.searchForm.min_price_min = parseFloat(
          this.searchForm.min_price_min
        ).toFixed(2)
      } else {
        return ''
      }
      if (this.searchForm.min_price_max) {
        this.searchForm.min_price_max = parseFloat(
          this.searchForm.min_price_max
        ).toFixed(2)
      } else {
        return ''
      }
    },
    setInt(event) {
      for (var i = 0; i < this.skuTableData.length; i++) {
        const item = this.skuTableData[i]
        item.stock = parseInt(item.stock)
        item.stock_alarm = parseInt(item.stock_alarm)
      }
    },
    editGoodsStatus(scope) {
      request({
        url: 'goods/' + scope.row.id,
        method: 'patch',
        data: {
          is_sold: this.merchandiseData[scope.$index].is_sold
        }
      })
        .then(res => {
          if (res.status === 0) {
            if (this.merchandiseData[scope.$index].is_sold === 1) {
              this.$message({
                message: this.generateCustomizeString('updateSuccessfully'),
                type: 'success'
              })
            } else {
              this.$message({
                message: this.generateCustomizeString('productDisabled'),
                type: 'success'
              })
            }
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
      // console.log(row)
    },
    editGoodsRecommend(scope) {
      request({
        url: 'goods/' + scope.row.id,
        method: 'patch',
        data: {
          is_promote: this.merchandiseData[scope.$index].is_promote
        }
      })
        .then(res => {
          if (res.status === 0) {
            if (this.merchandiseData[scope.$index].is_promote === 1) {
              this.$message({
                message: this.generateCustomizeString('updateSuccessfully'),
                type: 'success'
              })
            } else {
              this.$message({
                message: this.generateCustomizeString('brandUnpromoted'),
                type: 'success'
              })
            }
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
    },
    editAllSkuPrice() {
      for (var i = 0; i < this.skuTableData.length; i++) {
        this.skuTableData[i].price = parseFloat(this.editAllPrice).toFixed(2)
      }
      this.editAllPriceDialog = false
    },
    editAllSkuStock() {
      for (var i = 0; i < this.skuTableData.length; i++) {
        this.skuTableData[i].stock = parseInt(this.editAllStock)
      }
      this.editAllStockDialog = false
    },
    editAllSkuStockAlarm() {
      for (var i = 0; i < this.skuTableData.length; i++) {
        this.skuTableData[i].stock_alarm = parseInt(this.editAllStockAlarm)
      }
      this.editAllStockAlarmDialog = false
    },
    editClick(row) {
      this.$router.push({
        name: 'EditMerchandise',
        params: { goodsId: row.id }
      })
    },
    viewStockDetails(row) {
      this.dialogStockDetailsVisible = !this.dialogStockDetailsVisible
      this.goodsName = row.product_name
      this.goodsStockId = row.id
      this.fetchSkus(row)
    },
    updateStockClick(row) {
      var data = {}
      data.skus = []
      for (var i = 0; i < this.skuTableData.length; i++) {
        const item = this.skuTableData[i]
        const sku = {}
        sku.id = item.id
        sku.price = floatPriceCovertToIntPrice(item.price)
        sku.stock = item.stock
        sku.stock_alarm = item.stock_alarm
        data.skus.push(sku)
      }
      request({
        url: 'goods/' + this.goodsStockId + '/stock',
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('successUpdated'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.dialogStockDetailsVisible = false
          this.fetchData(this.currentPage)
        })
    },
    dismissStockDialog() {
      this.dialogStockFormVisible = false
    },
    createClick() {
      this.$router.push({ name: 'CreateMerchandise' })
    },
    freshClick() {
      this.fetchData(this.currentPage)
    },
    onSubmit() {
      if (this.bestDateArray === null) { this.bestDateArray = [] }

      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          params.category_id =
            params.selectedOptions.length === 2
              ? params.selectedOptions[1]
              : params.selectedOptions[0]
          if (params.min_price_min) {
            params.min_price_min = floatPriceCovertToIntPrice(
              params.min_price_min
            )
          }
          if (params.min_price_max) {
            params.min_price_max = floatPriceCovertToIntPrice(
              params.min_price_max
            )
          }
          if (
            this.shippingActivity === true ||
            this.shippingActivity === false
          ) {
            params.free_shipping_activity_id = null
          }
          if (
            this.shippingActivity &&
            this.shippingActivity !== true &&
            this.shippingActivity !== false
          ) {
            params.is_free_shipping = null
          }

          if (this.bestDateArray.length > 0) {
            params.start_best_use_before_at = this.bestDateArray[0]
            params.end_best_use_before_at = this.bestDateArray[1]
          }

          delete params.selectedOptions
          this.filters = params
          console.log(this.filters)
          this.fetchData(1)
        } else {
          console.log('data error')
        }
      })
    },
    onReset() {
      this.order_by = ''
      this.order_turn = ''
      this.$refs.searchForm.resetFields()
      this.is_alarm = false
      this.is_sold = null
      this.is_sold_out = false
      this.is_gift = false
      this.is_timed_special_price = false
      this.shippingActivity = null
      this.searchForm = Object.assign({}, originSearchFrom)
      this.filters = {}
      this.bestDateArray = []
      this.fetchData(1)
    },
    handleChange(value) {
      console.log(value)
    },
    handleCurrentChange(val) {
      this.fetchData(val)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) return [row.gap, 1]
        if (this.tableData[rowIndex].id !== this.tableData[rowIndex - 1].id) {
          return [row.gap, 1]
        } else {
          return [0, 0]
        }
      }
    },
    fetchCategories() {
      return new Promise((resolve, reject) => {
        request({
          url: '/categories',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].name
              const sub = response.data[i].sub_categories
              for (let j = 0; j < response.data[i].sub_categories.length; j++) {
                var sobj = {}
                sobj.value = response.data[i].sub_categories[j].id
                sobj.label = response.data[i].sub_categories[j].name
                sub[j] = sobj
              }
              obj.children = sub
              data[i] = obj
            }
            this.categoriesOptions = data
            this.categoriesOptions.unshift({ label: '全部', value: null })
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
      })
    },
    fetchBrand() {
      return new Promise((resolve, reject) => {
        request({
          url: '/brands?pages=all',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].brand_name
              data[i] = obj
            }
            this.brandOptions = data
            this.brandOptions.unshift({ label: '全部', value: null })
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchFullReduction() {
      return new Promise((resolve, reject) => {
        request({
          url: 'activity/fullreduction/list',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              if (
                new Date(response.data[i].expired_at).getTime() >
                new Date().getTime()
              ) {
                obj.value = response.data[i].id
                obj.label = response.data[i].title
                data[i] = obj
              }
            }
            this.fullReductionOptions = data
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchFreeShipping() {
      return new Promise((resolve, reject) => {
        request({
          url: 'activity/freeshipping/list',
          method: 'get'
        })
          .then(response => {
            if (response.data[0]) {
              this.freeShippingOptions.value = response.data[0].id
              this.freeShippingOptions.label = response.data[0].title
            }
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchSkus(row) {
      request({
        url: 'goods/' + row.id + '/stock',
        method: 'get'
      })
        .then(response => {
          const data = response.data
          for (var i = 0; i < data.length; i++) {
            const tmp = data[i]
            const item = {}
            item.id = tmp.id

            this.keys = Object.keys(tmp.property)
            let result = ''
            for (var j = 0; j < this.keys.length; j++) {
              const key = this.keys[j]
              result += key + ':' + tmp.property[key] + '  ' + '\r\n'
            }

            item.name = result
            item.stock = tmp.stock
            item.price = tmp.price / 100
            item.stock_alarm = tmp.stock_alarm
            data[i] = item
          }
          this.skuTableData = data
        })
        .catch(error => {
          console.warn(error)
        })
    },
    fetchData(page) {
      if (this.merchandiseListLoading) return
      this.merchandiseListLoading = true

      request({
        url: '/goods-list',
        method: 'get',
        params: {
          page: page,
          order_by: this.order_by,
          order_turn: this.order_turn,
          ...this.filters,
          page_size: this.numOfGoods
        }
      })
        .then(response => {
          const meta = response.meta
          const data = response.data
          this.merchandiseData = data

          // Add special price in merchandise list
          for (var i = 0; i < this.merchandiseData.length; i++) {
            var minSpecialPrice = this.merchandiseData[i].skus[0].timed_special_price
            var maxSpecialPrice = this.merchandiseData[i].skus[0].timed_special_price
            for (var j = 0; j < this.merchandiseData[i].skus.length; j++) {
              const tmp = this.merchandiseData[i].skus[j]
              this.merchandiseData[i].propertyKey = Object.keys(tmp.property)
              if (minSpecialPrice > tmp.timed_special_price) {
                var minSpecialPrice = tmp.timed_special_price
              }
              if (maxSpecialPrice < tmp.timed_special_price) {
                var maxSpecialPrice = tmp.timed_special_price
              }
            }
            this.merchandiseData[i].minSpecialPrice = minSpecialPrice
            this.merchandiseData[i].maxSpecialPrice = maxSpecialPrice
          }

          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.merchandiseListLoading = false
        })
    },
    deleteClick(row) {
      this.selectGoodsId = row.id
      this.dialogVisible = true
    },
    deleteMerchandise() {
      if (this.selectGoodsId === 0) return
      request({
        url: 'goods/' + this.selectGoodsId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('deleteFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.fetchData(this.currentPage)
          this.dialogVisible = false
          this.selectGoodsId = 0
        })
    },
    onRefersh() {
      this.fetchData(this.currentPage)
    },
    createQRCodeURL(goods_id) {
      return process.env.VUE_APP_MOBILE_URL +
          this.$store.state.shop.shop_domain_prefix + '/goodDetail/' + goods_id
    },
    createQrcode(row) {
      // console.log(row)
      const qrcodeLink = this.createQRCodeURL(row.id)
      // row.popoverVisible = true

      // let prices = ''
      // if (row.min_price == row.max_price) {
      //   prices = this.$options.filters.formatPrice(row.min_price)
      // } else {
      //   prices =
      //     this.$options.filters.formatPrice(row.min_price) +
      //     ' - ' +
      //     this.$options.filters.formatPrice(row.max_price)
      // }

      QRCode.toDataURL(qrcodeLink)
        .then(url => {
          // console.log(url)
          // this.qrcode = url
          var img = url

          var canvas = document.createElement('canvas')
          canvas.width = 600
          canvas.height = 600
          var context = canvas.getContext('2d')

          context.rect(0, 0, canvas.width, canvas.height)
          context.fillStyle = '#fff'
          context.fill()

          var myImage = new Image()
          myImage.setAttribute('crossOrigin', 'anonymous')
          myImage.src = row.images[0].image_url

          var myImage2 = new Image()
          myImage2.setAttribute('crossOrigin', 'anonymous')
          myImage2.src = img

          myImage.onload = function() {
            // 等待图片加载完成
            context.drawImage(
              myImage,
              20,
              20,
              560,
              (560 * myImage.height) / myImage.width
            )

            context.drawImage(myImage2, 400, 400, 200, 200)

            // // 价格颜色
            // context.fillStyle = '#f4002e'
            // context.font = '36px sans-serif'
            // context.fillText(prices, 20, 620)

            // const name = row.product_name

            // context.fillStyle = '#000'
            // context.font = '30px sans-serif'
            // context.fillText(name, 20, 676, 560)

            // download file
            const imgData = canvas.toDataURL('image/jpeg')
            const aLink = document.createElement('a')
            aLink.style.display = 'none'
            aLink.href = imgData
            aLink.download = row.product_name + '.jpg'
            // 触发点击-然后移除
            document.body.appendChild(aLink)
            aLink.click()
            document.body.removeChild(aLink)
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  },
  created: function() {
    this.fetchBrand()
    this.fetchCategories()
    this.fetchFullReduction()
    this.fetchFreeShipping()
    this.fetchData(1)
  },
  watch: {
    viewActived: function(newValue) {
      this.onRefersh()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
}

.el-table .warning-row {
  background: #f0f9eb;
}

.active {
  color: red;
  font-weight: 500;
}
.operation-panel {
  background: #f5f5f5;
}
.operation-panel .el-row {
  padding-top: 10px;
}
.price-font {
  font-weight: 600;
  font-size: small;
}
.expired {
  color: red;
}

.origin-price {
  text-decoration: line-through;
}

.special-price {
  color: red;
  font-weight: 600;
}
</style>
